import React from 'react';

interface IToggleChip {
    label: string;
    name?: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (e: any) => void;
}

export default function ToggleChip({ label, name, checked, disabled = false, onChange }: IToggleChip) {
    return (
        <label
            className={`position-relative d-inline-flex align-items-center gap-2 rounded-pill border px-3 py-2 ${
                checked ? 'border-primary bg-primary-subtle' : 'border-secondary-subtle'
            }`}
            style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.6 : 1,
                transition: 'background-color .15s ease, border-color .15s ease',
            }}
        >
            <input
                type="checkbox"
                name={name}
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                className="visually-hidden"
            />
            <span
                className={`d-inline-flex align-items-center flex-shrink-0 rounded-pill ${
                    checked ? 'bg-primary' : 'bg-secondary-subtle'
                }`}
                style={{ width: '2.75rem', height: '1.5rem', padding: '3px', transition: 'background-color .15s ease' }}
            >
                <span
                    className="bg-white rounded-circle shadow-sm"
                    style={{
                        width: '1.15rem',
                        height: '1.15rem',
                        transform: checked ? 'translateX(1.25rem)' : 'translateX(0)',
                        transition: 'transform .15s ease',
                    }}
                />
            </span>
            <span>{label}</span>
        </label>
    );
}
